export function section06(windowHeight) {
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section#section-6",
            start: "top 75%",
            end: "top 5%",
            scrub: true,
            once: false,
        },
    })
        .from(".section#section-6 .copy-wrapper .title", {
            opacity: 0,
        })
        .from(
            ".section#section-6 .copy-wrapper h2",
            {
                opacity: 0,
            },
            "<0.25"
        )
        .from(
            ".section#section-6 .giant-text-r",
            {
                right: "-100px",
            },
            "<"
        )
        .from(
            ".section#section-6 .copy-wrapper .content *",
            {
                opacity: 0,
                stagger: 0.15,
            },
            "<0.25"
        )
        .from(
            ".section#section-6 .giant-text-l",
            {
                left: "-100px",
            },
            "<0.25"
        )

    // SECTION 6 SLIDER GALLERY
    // var pinAmount_slider1 = $('.slider-gallery-wrapper#gallery-1 .slider-gallery').outerHeight() * 6;
    var pinAmount_slider1 = windowHeight * 6

    var slider_1_TL = gsap.timeline({
        scrollTrigger: {
            trigger: ".slider-gallery-wrapper#gallery-1",
            start: "center center",
            end: () => `+=${pinAmount_slider1}`,
            scrub: 1,
            pin: ".pin-section-1",
        },
    })

    slider_1_TL
        .from(".slider-gallery-wrapper#gallery-1 .slider-background", {
            opacity: 0,
            ease: "power2.inOut",
        })
        .from(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .slide#slide-1",
            {
                y: "0",
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator#indicator-1",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )

        .from(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .slide#slide-2",
            {
                y: "100%",
                ease: "power2.inOut",
            }
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator#indicator-2",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )

        .from(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .slide#slide-3",
            {
                y: "100%",
                ease: "power2.inOut",
            },
            ">"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator#indicator-3",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )

        .from(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .slide#slide-4",
            {
                y: "100%",
                ease: "power2.inOut",
            },
            ">"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator#indicator-4",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )

        .from(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .slide#slide-5",
            {
                y: "100%",
                ease: "power2.inOut",
            },
            ">"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator#indicator-5",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )

        .from(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .slide#slide-6",
            {
                y: "100%",
                ease: "power2.inOut",
            },
            ">"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-gallery .stage-indicator-wrapper .stage-indicator#indicator-6",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )

        .to(
            ".slider-gallery-wrapper#gallery-1 .slider-background",
            {
                opacity: 0,
                ease: "power2.inOut",
            },
            ">"
        )
}
